import { cn } from '@/lib/utils';

interface GlowCheckProps {
  done: boolean;
  onClick: () => void;
  ariaLabel: string;
  size?: 'sm' | 'md';
  className?: string;
}

const SIZE_CLASS = {
  sm: { box: 'size-4', svg: 'size-2.5' },
  md: { box: 'size-5', svg: 'size-3' },
} as const;

/**
 * Task checkbox with a rotating rainbow conic-gradient ring when unchecked.
 * Once checked, the ring collapses to a solid primary fill — done state is calm,
 * undone state is visually alive (recognition cue: "this still needs you").
 */
export function GlowCheck({ done, onClick, ariaLabel, size = 'md', className }: GlowCheckProps) {
  const s = SIZE_CLASS[size];
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      aria-pressed={done}
      className={cn(
        'glow-check grid shrink-0 place-items-center rounded-full transition-colors duration-150',
        s.box,
        done && 'is-done text-primary-foreground',
        className,
      )}
    >
      <span aria-hidden className="glow-check-ring" />
      {done && (
        <svg viewBox="0 0 12 12" className={cn('relative z-10', s.svg)} aria-hidden>
          <path
            d="M2 6.5 L5 9.5 L10 3.5"
            stroke="currentColor"
            strokeWidth="1.8"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );
}
